import { render, staticRenderFns } from "./shopLabel.vue?vue&type=template&id=3ed42bea&scoped=true"
import script from "./shopLabel.vue?vue&type=script&lang=js"
export * from "./shopLabel.vue?vue&type=script&lang=js"
import style0 from "./shopLabel.vue?vue&type=style&index=0&id=3ed42bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed42bea",
  null
  
)

export default component.exports